"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceOfContextualAttributes = isInstanceOfContextualAttributes;
exports.ensureNonContextualSubjectAttributes = ensureNonContextualSubjectAttributes;
exports.ensureContextualSubjectAttributes = ensureContextualSubjectAttributes;
exports.deduceAttributeContext = deduceAttributeContext;
exports.ensureActionsWithContextualAttributes = ensureActionsWithContextualAttributes;
function isInstanceOfContextualAttributes(attributes) {
    return Boolean(typeof attributes === 'object' &&
        attributes && // exclude null
        'numericAttributes' in attributes &&
        'categoricalAttributes' in attributes);
}
function ensureNonContextualSubjectAttributes(subjectAttributes) {
    let result;
    if (isInstanceOfContextualAttributes(subjectAttributes)) {
        const contextualSubjectAttributes = subjectAttributes;
        result = {
            ...contextualSubjectAttributes.numericAttributes,
            ...contextualSubjectAttributes.categoricalAttributes,
        };
    }
    else {
        // Attributes are non-contextual
        result = subjectAttributes;
    }
    return result;
}
function ensureContextualSubjectAttributes(subjectAttributes) {
    if (isInstanceOfContextualAttributes(subjectAttributes)) {
        return subjectAttributes;
    }
    else {
        return deduceAttributeContext(subjectAttributes);
    }
}
function deduceAttributeContext(attributes) {
    const contextualAttributes = {
        numericAttributes: {},
        categoricalAttributes: {},
    };
    Object.entries(attributes).forEach(([attribute, value]) => {
        const isNumeric = typeof value === 'number';
        if (isNumeric) {
            contextualAttributes.numericAttributes[attribute] = value;
        }
        else {
            contextualAttributes.categoricalAttributes[attribute] = value;
        }
    });
    return contextualAttributes;
}
function ensureActionsWithContextualAttributes(actions) {
    let result = {};
    if (Array.isArray(actions)) {
        // no context
        actions.forEach((action) => {
            result[action] = { numericAttributes: {}, categoricalAttributes: {} };
        });
    }
    else if (!Object.values(actions).every(isInstanceOfContextualAttributes)) {
        // Actions have non-contextual attributes; bucket based on number or not
        Object.entries(actions).forEach(([action, attributes]) => {
            result[action] = deduceAttributeContext(attributes);
        });
    }
    else {
        // Actions already have contextual attributes
        result = actions;
    }
    return result;
}
//# sourceMappingURL=attributes.js.map